import { NgModule } from '@angular/core'
import {
  BASE_SITE_CONTEXT_ID,
  BaseSiteService,
  ContextServiceMap,
  CURRENCY_CONTEXT_ID,
  CurrencyService,
  LANGUAGE_CONTEXT_ID,
  LanguageService,
  SiteContextConfigInitializer,
  SiteContextUrlSerializer
} from '@spartacus/core'
import { MbSiteContextConfigInitializer } from './config/mb-site-context-config-initializer'
import { MbSiteContextStoreModule } from './store/mb-site-context-store.module'
import { CountryLanguageService } from './facade/country-language.service'
import { MbSiteContextUrlSerializer } from './config/mb-site-context-url-serializer'

export function serviceMapFactory () {
  return {
    [LANGUAGE_CONTEXT_ID]: LanguageService,
    [CURRENCY_CONTEXT_ID]: CurrencyService,
    [BASE_SITE_CONTEXT_ID]: BaseSiteService,
    countryLanguage: CountryLanguageService,
  }
}

@NgModule({
  imports: [
    MbSiteContextStoreModule
  ],
  providers: [
    {
      provide: ContextServiceMap,
      useFactory: serviceMapFactory,
    },
    {
      provide: SiteContextConfigInitializer,
      useExisting: MbSiteContextConfigInitializer,
    },
    {
      provide: SiteContextUrlSerializer,
      useExisting: MbSiteContextUrlSerializer,
    },
  ]
})
export class SiteContextModule {
}
